import React from 'react';
import { AppService } from '@aperza/util';
import { HeaderMenuButton } from './menulist/HeaderMenuButton';
import { HeaderMenuList, HeaderMenuListItem } from './menulist/HeaderMenuList';
import { HeaderMenuIconButton } from './menulist/HeaderMenuIconButton';
import { useAperzaUserContext } from './AperzaUserContext';
import { AccountLoginButtonRow } from './account/AccountLoginButtonRow';
import style from './AccountUserButton.module.scss';
import { UserProfileTile } from './UserProfileTile';
import { addUtmParam } from '../addUtmParam';
const accountServerHost = AppService.accountServerHost();
const dxServerHost = AppService.cloudServerHost();
export const headerAccountMenuItems = [
    {
        title: 'Myページ トップ',
        url: accountServerHost,
    },
    {
        title: '登録情報の変更',
        url: `${accountServerHost}/account`,
    },
    {
        title: 'メールマガジン・通知設定',
        url: `${accountServerHost}/mail`,
    },
    {
        title: 'アペルザTV 通知設定',
        url: `${AppService.tvServerHost()}/mypage`,
    },
];
const dxMenuItems = [
    {
        title: '顧客情報管理',
        url: `${dxServerHost}/customer/index.html`,
    },
    {
        title: 'メール配信',
        url: `${dxServerHost}/mail/delivery/index.html`,
    },
    {
        title: '販売管理',
        url: `${dxServerHost}/sales/index.html`,
    },
    {
        title: 'アペルザTV レポート',
        url: `${dxServerHost}/tv/report/index.html`,
    },
    {
        title: 'Web FAX',
        url: `${dxServerHost}/fax/documents/received/bookmarked`,
    },
];
export default function AccountUserButton() {
    const { isBusiness, isActiveBusinessCart, isLogin, serviceType, logoutUrl, } = useAperzaUserContext();
    return (React.createElement(HeaderMenuButton, { type: "accountDropdown", header: React.createElement(React.Fragment, null,
            isLogin && React.createElement(UserProfileTile, null),
            !isLogin && 'アカウント'), headerUrl: isLogin
            ? addUtmParam(`${AppService.accountServerHost()}/account`, 'header', serviceType)
            : undefined, button: (isActive) => (React.createElement(HeaderMenuIconButton, { isActive: isActive, label: "\u30A2\u30AB\u30A6\u30F3\u30C8", icon: `${AppService.staticServerHost()}/common/images/header/user.svg`, iconHover: `${AppService.staticServerHost()}/common/images/header/user_red.svg` })), footer: !isLogin && React.createElement(AccountLoginButtonRow, null) },
        isLogin && (React.createElement(React.Fragment, null,
            React.createElement(HeaderMenuList, { bordered: true }, headerAccountMenuItems.map((item) => (React.createElement(HeaderMenuListItem, { item: item, key: item.title.toString() })))),
            isActiveBusinessCart && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: style.logoWrapper },
                    React.createElement("img", { alt: "\u30A2\u30DA\u30EB\u30B6EC", src: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_ec.svg`, height: 20 })),
                React.createElement(HeaderMenuList, { bordered: true },
                    React.createElement(HeaderMenuListItem, { item: {
                            title: '注文一覧',
                            url: `${AppService.businessServerHost()}/f/order/index.html`,
                        }, key: "\u6CE8\u6587\u4E00\u89A7" })))),
            isBusiness && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: style.logoWrapper },
                    React.createElement("img", { alt: "\u30A2\u30DA\u30EB\u30B6DX", src: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_dx.svg`, height: 20 })),
                React.createElement(HeaderMenuList, { bordered: true }, dxMenuItems.map((item) => (React.createElement(HeaderMenuListItem, { item: item, key: item.title.toString(), target: "_blank" })))))),
            React.createElement(HeaderMenuList, { bordered: true },
                React.createElement(HeaderMenuListItem, { item: {
                        title: 'ログアウト',
                        url: logoutUrl(),
                    }, key: "\u30ED\u30B0\u30A2\u30A6\u30C8" })))),
        !isLogin && (React.createElement("div", { className: style.bodyWrapper },
            React.createElement("p", { className: style.bodyText }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u6A5F\u80FD\u3092\u5229\u7528\u3059\u308B\u306B\u306F\u30ED\u30B0\u30A4\u30F3\u304C\u5FC5\u8981\u3067\u3059\u3002\u30A2\u30DA\u30EB\u30B6ID\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u304A\u5BA2\u69D8\u306F\u4EE5\u4E0B\u3088\u308A\u767B\u9332\u9858\u3044\u307E\u3059\u3002")))));
}
